import { DefaultTheme, rgba } from '../../components/theme';
import { ColorPaletteGrey } from '../../components/theme.palette';

export const CSS = {
	container: 'c-MapModeLegendContainer',
	legendItem: 'c-MapModeLegendItem',
	legendItemHidden: 'c-MapModeLegendItem--hidden',
	legendIcon: 'c-MapModeLegendItem__icon',
	legendText: 'c-MapModeLegendItem__text',
	legendEye: 'c-MapModeLegendItem__eye',
	legendEyeIcon: 'c-MapModeLegendItem__eyeIcon',
	legendEyeIconHidden: 'c-MapModeLegendItem__eyeIcon--hidden',

	legendIconLine: 'c-MapModeLegendItem__icon__line',
	legendIconDevice: 'c-MapModeLegendItem__icon__device',
	legendCollectionLabelOverride: 'c-MapModeLegendItem__icon__label',
};

export const Style = {
	[CSS.container]: {
		position: 'relative',
		flexGrow: '1',
		maxHeight: '30%',
		padding: DefaultTheme.space(1),
		overflow: 'auto',
	},
	[CSS.legendItem]: {
		display: 'flex',
		height: '28px',
		boxSizing: 'border-box',
		padding: `${DefaultTheme.space(1)} ${DefaultTheme.space(2)}`,
	},
	[CSS.legendIcon]: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '32px',
		height: '100%',
	},
	[CSS.legendIconLine]: {
		height: '4px',
		width: '100%',
	},
	[CSS.legendIconDevice]: {
		width: '16px',
		height: '16px',
	},
	[CSS.legendCollectionLabelOverride]: {
		width: '100%',
		padding: 0,
		textAlign: 'center',
	},
	[CSS.legendText]: {
		display: 'flex',
		alignItems: 'center',
		paddingLeft: '12px',
	},
	[CSS.legendItemHidden]: {
		[`& .${CSS.legendIcon}, & .${CSS.legendText}`]: {
			opacity: 0.4,
		},
	},
	[CSS.legendEye]: {
		display: 'flex',
		alignItems: 'center',
		marginLeft: 'auto',
		padding: 0,
		border: 'none',
		background: 'none',
		cursor: 'pointer',
	},
	// Orange = layer visible, grey = hidden (matches the form-builder eye symbology). The hidden rule
	// follows the base so its equal-specificity color wins when both classes are present.
	[CSS.legendEyeIcon]: {
		fontSize: '16px',
		color: DefaultTheme.color.accent,
	},
	[CSS.legendEyeIconHidden]: {
		color: rgba(ColorPaletteGrey.C600),
	},
};
